// KILL STREAKS:
module.exports = [{
  name: "Nuke",
  kills: 25,
  activate: function (game, player) {
    if (!game.nukeTimer) {
      game.incStat("n", player);
      game.startNuke(player);
      return true;
    }
    return false;
  }
}];